import { MenuDownIcon } from 'assests/GmsIcons';
import { Link } from 'react-router-dom';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { AnalyticsContext } from '../Context/AnalyticsContext';

export const TimezoneMenu = () => {
    const context = useContext(AnalyticsContext);
    const { showMenu, ref, handleClick } = useClickOutside();
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [timezones, setTimezones] = useState<{ name: string; abbreviation: string }[]>([]);

    useEffect(() => {
        const fetchTimezones = async () => {
            const allTimezones = moment.tz.names();
            const timezonesWithAbbreviations = allTimezones.map(timezone => ({ name: timezone, abbreviation: moment.tz(timezone).format('z') }));
            setTimezones(timezonesWithAbbreviations);
        };
        fetchTimezones();
    }, []);

    const filteredTimezones = timezones.filter(timezone =>
        timezone.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        timezone.abbreviation.toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    const updateTimeZone = (name: string, abbreviation: string) => {
        context.setSelectedTimezone({ name, abbreviation });
        context.setDateRange(name)
        handleClick();
        setSearchQuery('');
    };
    
    return (
        <div ref={ref} className='tw-relative tw-bg-white tw-z-40'>        
            <div onClick={handleClick} className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} hover:tw-bg-[#EBECF0] tw-p-2 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>    
                <button className={`tw-text-sm tw-font-normal tw-text-[#6B778C]`}>Timezone <span className={`tw-text-sm tw-text-[#172B4D]`}>{context?.selectedTimezone?.abbreviation}</span></button>
                <MenuDownIcon/>
            </div>
            {/* tw-origin-top-left tw-absolute  tw-w-60 tw-mx-3 tw-my-1 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0] */}
            {showMenu ? (
                <div className={`tw-origin-top-left tw-max-h-[300px] tw-overflow-scroll tw-absolute tw-w-auto tw-my-1 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                    <input className='input-field-dm' type='text' placeholder='Search' value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                    {filteredTimezones?.map((timezone, index) => (
                        <Link className={`tw-flex tw-justify-between tw-items-center tw-px-2 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} key={timezone.name + index.toString} to="#" role="menuitem" onClick={() => { updateTimeZone(timezone?.name, timezone?.abbreviation) }}>
                            <span>{timezone.name}</span>
                            <span>{timezone.abbreviation}</span>
                        </Link>
                    ))}
                </div>                        
            ) : null}
        </div> 
    );
}